module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-indicator clickable",
    class: {
      visible: _vm.visible
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mail-log')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "email-indicator-text"
  }, [_vm._v("\n        " + _vm._s(_vm.currentStatus) + "\n        "), _c('div', {
    staticClass: "truncate email-indicator-subtext"
  }, [_vm._v(_vm._s(_vm.emailToValue))])]), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "white"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("close_circle_outline")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652d019c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/EmailIndicator.vue
// module id = 2582
// module chunks = 1